import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-io',
  templateUrl: './io.component.html'
})
export class IoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
